import axios, { type AxiosInstance } from 'axios';

// ===================================
// API de Autenticación (vilox.api)
// ===================================
export const authAPI: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true,
});

// ===================================
// API de Mantenimiento (microservicio)
// ===================================
export const maintenanceAPI: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_MAINTENANCE_API_URL || 'http://localhost:8001/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true,
});

// ===================================
// Interceptores para AMBAS APIs
// ===================================
const setupInterceptors = (apiInstance: AxiosInstance) => {
    // Request: Agregar token
    apiInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    // Response: Manejar errores
    apiInstance.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                // En la app unificada, el logout se gestiona centralmente si falla la auth
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('menus');
                window.location.href = '/login';
            }
            return Promise.reject(error);
        }
    );
};

setupInterceptors(authAPI);
setupInterceptors(maintenanceAPI);

// Exportar por defecto el API de auth (compatibilidad)
export default authAPI;
